import styled from 'styled-components';
import { LoadingButton } from './LoadingButton';

export const StyledFooterButton = styled(LoadingButton)`
  height: 42px;
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  border-radius: 10px;
`;
